"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var __1 = require("..");
var base_1 = require("../components/base");
var Labels_1 = require("../components/Labels");
var OrdersComponents_1 = require("../components/OrdersComponents");
var styles_1 = require("../styles");
function Orders(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ className: "twap-orders twap-orders-wrapper ".concat(className) }, { children: [(0, jsx_runtime_1.jsxs)(StyledHeader, __assign({ className: "twap-orders-header" }, { children: [(0, jsx_runtime_1.jsxs)(StyledHeaderTop, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledRowFlex, __assign({ justifyContent: "flex-start", gap: 5, style: { width: "auto" } }, { children: (0, jsx_runtime_1.jsx)(Labels_1.OrdersLabel, {}) })), (0, jsx_runtime_1.jsx)(base_1.Odnp, {})] }), (0, jsx_runtime_1.jsx)(OrdersComponents_1.OrdersSelectTabs, {})] })), (0, jsx_runtime_1.jsx)(OrdersComponents_1.SelectedOrders, {})] })));
}
function OrdersPanel(_a) {
    var className = _a.className, noPortal = _a.noPortal, children = _a.children;
    if (noPortal) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) || (0, jsx_runtime_1.jsx)(Orders, { className: className });
    }
    return (0, jsx_runtime_1.jsx)(base_1.Portal, __assign({ id: __1.ORDERS_CONTAINER_ID }, { children: children ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }) : (0, jsx_runtime_1.jsx)(Orders, { className: className }) }));
}
exports.OrdersPanel = OrdersPanel;
var StyledHeader = (0, material_1.styled)(material_1.Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 13,
});
var StyledContainer = (0, material_1.styled)("div")({
    width: "100%",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 15,
    "& *": {
        fontFamily: "inherit",
        color: "inherit",
    },
});
var StyledHeaderTop = (0, material_1.styled)(material_1.Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "& .twap-label": {
        fontSize: 18,
    },
});
